import React, { ReactNode, RefObject } from "react";
import styles from "./utility-nav.module.scss";
import Link from "next/link";
import { useRouter } from "next/router";
import { PageReference } from "../../typescript/response";
import { CSLocale } from "../../typescript/component";
import { LanguageSelector } from "../ui";
import { usePageState } from "../../context/pageContext";

export const UtilityNav = ({
  ref,
  children,
  contact_us,
  locations,
  showLanguageSelector=true,
  languages,
  header_strings
}: props) => {
  const { locale, defaultLocale } = useRouter();
  const isDefaultLocale = locale === defaultLocale;
  const [isNavOpen, setIsNavOpen] = usePageState('isNavOpen');
  const [isSearchOpen, setIsSearchOpen] = usePageState('isSearchOpen');

  const handleLocaleChange = (_newLocale: string) => {
    setIsNavOpen(false);
    setIsSearchOpen(false);
  };
  
  return (
    <div
      ref={ref}
      className={styles.utilityNav}>
      <div className={styles.container}>
        <div className={styles.utilityNavGrid}>
          {children}
          <div className={styles.utilityNavItems}>
            {contact_us?.page_reference?.[0]?.url && (
              <div className={`${styles.utilityNavItem} ${styles['utilityNavItem--contact']}`}>
                <Link
                  href={`${isDefaultLocale ? '' : `/${locale}`}${contact_us.page_reference[0].url}`}
                >
                  <span className={styles.locations}>{contact_us.label}</span>
                </Link>
              </div>
            )}

            {locations?.page_reference?.[0]?.url && (
              <div className={`${styles.utilityNavItem} ${styles['utilityNavItem--location']}`}>
                <Link
                  href={`${isDefaultLocale ? '' : `/${locale}`}${locations.page_reference[0].url}`}
                  className={styles.mainLink}
                >
                  <span className={styles.locations}>{locations.label}</span>
                </Link>
              </div>
            )}
            {showLanguageSelector && (
              <LanguageSelector
                languages={languages}
                currentLocale={locale || 'en-us'}
                onLocaleChange={handleLocaleChange}
                className={`${styles.utilityNavItem} ${styles['utilityNavItem--languages']}`}
                hideDropdown={true}
                header_strings={header_strings}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

interface props {
  ref?: RefObject<HTMLDivElement | null>;
  children: ReactNode;
  contact_us?: PageReference;
  locations?: PageReference;
  showLanguageSelector?: boolean;
  languages: CSLocale[] | null;
  header_strings?: Record<string, string>;
}